const resetHorizontalRecs = () => {
  var screenWidth = $(window).innerWidth(),
    $recListContain = $('#rec-list-contain');
  $.each($('#horz-rec .rec-list'), function() {
    var $horzListContain = $(this).parent();
    if ($horzListContain.width() > $(this).width()) {
      $horzListContain.css('overflow', 'visible');
      $(this).css('margin-left', '7%');
    } else {
      $horzListContain.css('overflow', 'hidden');
      $(this).css('margin-left', '0');
    }
  });
  if ($recListContain.width() > $('#rec-list-contain .rec-list').width() || screenWidth > 992) {
    $recListContain.css('overflow', 'visible-x');
    (screenWidth < 992) ? $recListContain.css('margin-left', '7%'): $recListContain.css('margin-left', '0');
  } else {
    $recListContain.css('overflow', 'hidden');
    $recListContain.css('margin-left', '0');
  }
}

const pageSetup = () => {
  $('.rec-nav .nav-up,.alt-image-nav-up,.alt-image-nav-left,.rec-nav-mobile .nav-left').addClass('disabled-arrow');
  $('.rec-nav .nav-down,.alt-image-nav-down,.alt-image-nav-right,.rec-nav-mobile .nav-right').removeClass('disabled-arrow');
  $('ul.rec-list').css('top', '0');
  resetHorizontalRecs();
  ($('#vert-rec .rec-list li').length <= 4) ? $('#vert-rec .rec-nav').hide(): $('#vert-rec .rec-nav').show();
  if (!$('.bundle-display-page').length > 0) {
    ($('.collection-list li').length < 7) ? $('.collection-list .fa-angle-left,.collection-list .fa-angle-right').hide() : $('.collection-list .fa-angle-left,.collection-list .fa-angle-right').show();
  } else {
    ($('.collection-list li').length < 4) ? $('.collection-list .fa-angle-left,.collection-list .fa-angle-right').hide() : $('.collection-list .fa-angle-left,.collection-list .fa-angle-right').show();
  }
};

export {
  pageSetup,
  resetHorizontalRecs
}
